// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"74466d6f","20":"d24937e8","49":"78eca0a9","72":"5fb361cc","258":"ed76e130","406":"1df9c73c","476":"cfd5ffdf","523":"b1b899c0","680":"42742e10","885":"9c4d09e1"}[chunkId] + ".chunk.js";
};